<fieldset [formGroup]="signatureForm" [hidden]="(visible$ | async) === false">
    <ng-container *ngrxLet="signature$; let signature">
        <div class="row mb-md-3 mb-2">
            <div class="col">
                <p>{{ signature.description }}</p>
            </div>
        </div>
        <pace-forms-choices
            [choices]="signature.choices"
            *ngIf="signature.choices"
            [formControl]="radioControl"
        ></pace-forms-choices>
        <div class="row mb-md-3 mb-2">
            <span class="col-md-2 col-form-label col-4 text-start">{{ signature.label }}</span>
            <div class="col-md-auto col-12">
                <canvas
                    #signatureCanvas
                    class="cse-signature-canvas signature-canvas"
                    [ngClass]="{
                        'ng-invalid': signaturePad && signaturePad.isEmpty && firstNameControl.enabled,
                        disabled: firstNameControl.disabled,
                    }"
                ></canvas>
            </div>
            <div class="col-md-auto col-3 pt-md-0 pt-3">
                <button
                    type="button"
                    class="btn btn-secondary btn-lg"
                    (click)="clearSignature()"
                    [disabled]="signature.disabled || (readOnly$ | async)"
                    translate="F4M_SUMMARY_MODAL_CLEAR_LABEL"
                ></button>
            </div>
            @if (displayHistoryButton$ | async) {
                <div class="col-auto pt-sm-0 pt-4 ms-auto d-flex align-items-center">
                    <pace-forms-history-button [uniqueId]="signature.uniqueId"></pace-forms-history-button>
                </div>
            }
        </div>
        <div class="row mb-md-3 mb-2">
            <label class="col-md-2 col-form-label col-4 text-start" for="{{ signature.nameXmlId }}-firstName"
                >First Name:</label
            >
            <div class="col-md-10 col-12">
                <input
                    type="text"
                    class="form-control input-md name-input"
                    id="{{ signature.nameXmlId }}-firstName"
                    [formControl]="firstNameControl"
                />
            </div>
        </div>
        <div class="row mb-md-3 mb-2">
            <label class="col-md-2 col-form-label col-4 text-start" for="{{ signature.nameXmlId }}-lastName"
                >Last Name:</label
            >
            <div class="col-md-10 col-12">
                <input
                    type="text"
                    class="form-control input-md name-input"
                    id="{{ signature.nameXmlId }}-lastName"
                    [formControl]="lastNameControl"
                />
            </div>
        </div>
        <div class="row mb-md-3 mb-2" *ngIf="showEmailField$ | async">
            <label class="col-md-2 col-form-label col-4 text-start" for="{{ signature.nameXmlId }}-email">Email:</label>
            <div class="col-md-10 col-12">
                <input
                    type="text"
                    class="form-control input-md name-input"
                    id="{{ signature.nameXmlId }}-email"
                    [formControl]="emailControl"
                />
            </div>
        </div>
    </ng-container>
</fieldset>
